import { rendererFormat } from 'Domain/Scene/Handler/RenderHandler'
import { PostReferencePhoto } from 'Infrastructure/Service/ProjectService'
import { InitCameraRatio } from '../Handler/CameraHandler'
import { threeEngine } from 'Domain/Scene/Engine/ThreeEngine'

let done = false

export const ShotDone = () => done

export const disposeSnapshotRenderer = (renderer) => {
    if (!renderer) return
    renderer.dispose()
    const canvas = renderer.domElement
    if (canvas?.parentNode) {
        canvas.parentNode.removeChild(canvas)
    }
}

export const ShotScene = ( renderer, center, scene, projectMetas ) => {

    let
      viewports = [{name:'front'}, {name:'top'}, {name:'bottom'} ],
      cam,
      offsetWidth = 200,
      offsetHeight = 200

    for ( var i = 0; i < viewports.length; ++i ) {
      /** VIEWPORT SETUP */
      switch(viewports[i].name){
        case 'top':
            rendererFormat(renderer, offsetWidth, 0, offsetWidth, offsetHeight)
            break
        case 'front':
            rendererFormat(renderer, 0, offsetHeight/2, offsetWidth*2, offsetHeight*2)
            break
        case 'bottom':
            rendererFormat(renderer, 0, 0, offsetWidth, offsetHeight)
            break
        default:
            break
      }

      /** CAMERA SETUP */
      cam = threeEngine.getCamera(viewports[i].name)
      cam.lookAt( center )
      InitCameraRatio(offsetWidth, offsetHeight, cam)

      renderer.render(scene, cam)
    }

    PostReferencePhoto(projectMetas.hash, renderer.domElement.toDataURL())
      .then(() => { done = true })
      .finally(() => disposeSnapshotRenderer(renderer))

}

